import { z } from 'zod';

export const ListBaseModel = z.object({
  count: z.number().int(),
  next: z.string().url().nullable(),
  previous: z.string().url().nullable(),
  results: z.unknown(),
});
